import { COURSE_ROUTE_NAME } from "@/libs/route-name";

export const CourseRouteName = () => {
  return {
    path: "technician/courses",
    name: COURSE_ROUTE_NAME.HOME,
    component: () => import("@/pages/courses/index.vue")
  };
};

export const CourseDetailRouteName = () => {
  return {
    path: "technician/courses/:id",
    name: COURSE_ROUTE_NAME.DETAIL,
    component: () => import("@/pages/courses/course-detail.vue")
  };
};

export const PostCourseRouteName = () => {
  return {
    path: "technician/post-course",
    name: COURSE_ROUTE_NAME.POST,
    component: () => import("@/pages/courses/post-course.vue")
  };
};
